export default __webpack_public_path__ + "static/tooltip-critical-dont-dark-4fa744819035c5580431df4fd23ecaee.png";